import services from "@/services"
import moment from 'moment';

const state  = {
    items : [],
    data : {},
    // sla : {},
    statusSubmit : false
}
const getters = {
    // orderFeeItems : state => state.items,
    orderFeeItems: (state) => {
        let groupOrderFee = state.items.map((x) => {
          x.seller_comission_display = x.seller_comission_display + "%";
          if(x.comission_updated_date == "0001-01-01T00:00:00Z"){
            x.comission_updated_date = "" 
          }
          else{
            x.comission_updated_date = moment(String(x.comission_updated_date)).format('DD MMM YYYY HH:mm');
          }
          x.created_date = moment(String(x.created_date)).format('DD MMM YYYY HH:mm');
          x.actions = {
            id: x.id,
            comission: x.seller_comission, 
            edit: "enable",
            delete: "disable",
          };
          return x;
        });
        return groupOrderFee;
      },
}

const mutations = {
    setOrderFeeItems : (state,items) => {
        state.items = items
    },
    setSellerItems : (state,items) => {
        state.items = items
    },
    successSubmit : (state,status) => {
        state.statusSubmit = status
    },
    setStatusSubmit: (state, status) => {
        state.successInput = status;
    },
}

const actions = {
    getAll({ commit, dispatch }, param) {
        services.setHeader()
        dispatch("setLoadingTable", true, { root: true })
        return new Promise((resolve , reject) => {
            services.get('sellercomission',param).then((response) => {
                commit('setSellerItems',response.data.data.items)
                resolve(response)
            }).catch((error) => {
                reject(error)
            }).finally(()=>{
                dispatch("setLoadingTable", false, { root: true })
            })
        })
    },
    getOneOrderFeeSetting({ commit, dispatch }) {
        dispatch("setLoadingGlobal", true, { root: true })
        return new Promise((resolve , reject) => {
            services.get('orderfeesetting').then((response) => {
                commit('setOrderFeeItems',response.data.data.items)
                resolve(response)
            }).catch((error) => {
                reject(error)
            }).finally(()=>{
                dispatch("setLoadingGlobal", false, { root: true })
            })
        })
    },
    updateOrderFeeSetting({ commit, dispatch }, payload) {
        dispatch("setLoadingGlobal", true, { root: true })
        return new Promise((resolve, reject) => {
          services
            .put("orderfeesetting", payload)
            .then((response) => {
              commit("setStatusSubmit", true);
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            }).finally(()=>{
                dispatch("setLoadingGlobal", false, { root: true })
            })
        });
      },
    submitComission({ commit, dispatch }, payload) {
        dispatch("setLoadingGlobal", true, { root: true })
        return new Promise((resolve , reject) => {
            services.put('sellercomission/'+payload.seller_id, payload).then((response) => {
                commit('successSubmit',true)
                resolve(response)
            }).catch((error) => {
                reject(error)
            }).finally(()=>{
                dispatch("setLoadingGlobal", false, { root: true })
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}